<template>
  <v-row class="card pl-2 pr-2">
    <v-col class="pl-2 pr-2" cols="auto"><small class="d-block">{{ $t('appointment.account', { account: firstAppointment.account }) }}</small><small class="d-block">{{ $t('appointment.phone', { phone: firstAppointment.phoneNumber }) }}</small></v-col>
    <v-spacer></v-spacer>
    <v-col class="pa-0" v-if="showCount" cols="auto">
      <div class="d-flex is-full-height">
        <div class="pb-3 pt-3 pl-2 pr-2 is-full-height d-flex align-center"><small>{{ firstAppointmentDuration }}</small></div>
        <div class="appointment-count pb-3 pt-3 pl-2 pr-2 is-full-height d-flex align-center" :class="appointmentCountColor"><span class="white--text">{{ appointmentCount }}</span></div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    event: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    firstAppointment () {
      return this.event.appointments[0]
    },
    firstAppointmentDuration () {
      let { start, end } = this.firstAppointment
      start = this.$time(start).format('hh:mm')
      end = this.$time(end).format('hh:mm')
      return `${start} - ${end}`
    },
    appointmentCount () {
      const appointmentCount = this.event.appointments.length
      const levels = [10, 5]

      for (const level of levels) {
        if (appointmentCount >= level) return `${appointmentCount}+`
      }
      return appointmentCount
    },
    appointmentCountColor () {
      return this.event.appointments.length >= 10 ? 'error' : 'info'
    },
    showCount () {
      return this.event.appointments.length > 1
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  background-color #FEDA88
  color #212121

.appointment-count
  width 30px

.is-full-height
  height 100%
</style>
